import { useAccountStore } from "features/Account/store/useAccountStore";
import { checkIsArrayEmpty } from "features/Common/modules/DataTypes/utils/Array.utils";
import { LICENSE_TYPE_LABELS } from "features/MySubscriptions/constants/MySubscriptions.constants";

export const useAccessTypePlanModalWrapper = () => {
  const accessTypePlans = useAccountStore((state) => state.accessTypePlans);
  const accessTypePlansFeatureKey = useAccountStore(
    (state) => state.accessTypePlansFeatureKey
  );
  const accessTypePlansModalTitle = useAccountStore(
    (state) => state.accessTypePlansModalTitle
  );
  const showAccessTypePlansModal = useAccountStore(
    (state) => state.showAccessTypePlansModal
  );
  const closeAccessTypePlansModal = useAccountStore(
    (state) => state.closeAccessTypePlansModal
  );

  const showPlansModal =
    showAccessTypePlansModal &&
    Boolean(accessTypePlansFeatureKey) &&
    !checkIsArrayEmpty(accessTypePlans);

  const modalTitle =
    accessTypePlansModalTitle ??
    LICENSE_TYPE_LABELS[accessTypePlansFeatureKey] ??
    "";

  return {
    showPlansModal,
    closeAccessTypePlansModal,
    accessTypePlans,
    accessTypePlansFeatureKey,
    modalTitle,
  };
};
